export default "__VITE_ASSET__D1huTFzh__"